import Vue from 'vue';
import VueResource from 'vue-resource';
import _ from 'underscore';
import html from '../templates/story-editor-component.html';
import '../assets/css/story-editor-component.css';
import StampListComponent from './visual-editor-stamps-list-component';
import previewService from './preview-services';
import PreviewComponent from './visual-preview-component';
import PreviewSquareComponent from './visual-preview-square-compontent';
import DropZone from './droppable-zone';


Vue.use(VueResource);
export default Vue.component('story-editor', {
  template: html,
  components: {
    StampListComponent,
    PreviewComponent,
    PreviewSquareComponent,
    DropZone
  },
  props: {
    story: {
      type: Object,
      required: true
    },
    photoUrl: {
      type: String,
      required: true
    },
    size: {
      type: Object,
      required: true
    },
    faceLandmarks: {
      type: Object,
      required: true
    },
    host: {
      default: 'http://work.stk.908.vc'
    },
    squarePhotoUrl: {
      type: String,
      required: true
    },
    squareSize: {
      type: Object,
      required: true
    },
    squareFaceLandmarks: {
      type: Object,
      required: true
    },
    usage: {
      type: String
    }
  },
  data() {
    return {
      verticalLoadStart: false,
      squareLoadStart: false,
      stampIndex: null,
      parsedStory: this.story,
      square: false,
      packsQuery: '',
      storyId: this.story.data.id,
      changedType: null,
      packsList: '',
      stampsList: '',
      changeShape: true,
      pivotId: '',
      showPacksTrigger: false,
      differentShapeIntendSquare: {},
      differentShapeIntendVertical: {},
      squareSettings: null,
      verticalSettings: null,
      staticStampChanges: null,
      demoUrl: 'https://m.me/1532404563448549?ref=',
      refreshComponents: true,
      framePositionTrigger: true,
      commonPack: [],
      loader: null,
      photoArray: [
        {
          title: 'lisa',
          vertical: {
            faceLandmarks: {
              eyes: [{x: 58.6, y: 165.9}, {x: 160.3, y: 166}],
              mouth: [{x: 63.5, y: 287.5}, {x: 146.75, y: 288.35}],
              nose: {
                x: 97.5,
                y: 167
              }
            },
            url: '/stories/lisa_vertical.png'
            // url: 'http://dev.stk.908.vc/stories/lisa_vertical.png'
          },
          square: {
            faceLandmarks: {
              eyes: [{x: 163.6, y: 165.9}, {x: 265.3, y: 166}],
              mouth: [{x: 168.5, y: 287.5}, {x: 251.75, y: 288.35}],
              nose: {
                x: 202.5,
                y: 167
              }
            },
            url: '/stories/lisa_square.png'
            // url: 'http://dev.stk.908.vc/stories/lisa_square.png'
          }
        },
        {
          title: 'monroe',
          vertical: {
            faceLandmarks: {
              eyes: [{x: 102, y: 136.3}, {x: 186.3, y: 160}],
              mouth: [{x: 88, y: 216}, {x: 157, y: 234.8}],
              nose: {
                x: 141,
                y: 147
              }
            },
            // url: 'http://dev.stk.908.vc/stories/monroe_vertical.png'
            url: '/stories/monroe_vertical.png'
          },
          square: {
            faceLandmarks: {
              eyes: [{x: 201.3, y: 126.6}, {x: 304.9, y: 156.4}],
              mouth: [{x: 186.7, y: 224.4}, {x: 265.7, y: 248.3}],
              nose: {
                x: 248,
                y: 143
              }
            },
            // url: 'http://dev.stk.908.vc/stories/monroe_square.png'
            url: '/stories/monroe_square.png'
          }
        },
        {
          title: 'leonardo',
          vertical: {
            faceLandmarks: {
              eyes: [{x: 52, y: 81.7}, {x: 157, y: 92.2}],
              mouth: [{x: 45, y: 209}, {x: 122, y: 217}],
              nose: {
                x: 82,
                y: 85
              }
            },
            // url: 'http://dev.stk.908.vc/stories/leonardo_vertical.png'
            url: '/stories/leonardo_vertical.png'
          },
          square: {
            faceLandmarks: {
              eyes: [{x: 157, y: 81.7}, {x: 262, y: 92.2}],
              mouth: [{x: 150, y: 209}, {x: 227, y: 217}],
              nose: {
                x: 187,
                y: 85
              }
            },
            // url: 'http://dev.stk.908.vc/stories/leonardo_square.png'
            url: '/stories/leonardo_square.png'
          }
        }
      ],
      currentPhotoIndex: 0,
      currentPhoto: {
        vertical: {
          url: ''
        },
        square: {
          url: ''
        }
      }
    };
  },
  methods: {
    typeTrigger(obj) {
      this.changedType = obj;
      console.log('type obj ', obj);
    },
    updateComponents() {
      this.refreshComponents = !this.refreshComponents;
    },
    setStampIndex(index) {
      if (index === 0) {
        // should be string in this scenario, cuz number leads to error and parsed as false
        this.stampIndex = '0';
      } else {
        this.stampIndex = index;
      }
      console.log('this.stampIndex ', this.stampIndex);
    },
    // Rectangle to square and opposite
    changeStoryShape() {
      this.square = !this.square;
      this.updateStoryShape();
    },
    setNewCurrentPhoto() {
      this.currentPhoto = this.photoArray[this.currentPhotoIndex];
      this.updateComponents();
    },
    nextPhoto() {
      if (this.photoArray.length - 1 === this.currentPhotoIndex) {
        this.currentPhotoIndex = 0;
      } else {
        this.currentPhotoIndex = this.currentPhotoIndex + 1;
      }
      this.setNewCurrentPhoto();
    },
    prevPhoto() {
      if (this.currentPhotoIndex === 0) {
        this.currentPhotoIndex = this.photoArray.length - 1;
      } else {
        this.currentPhotoIndex = this.currentPhotoIndex - 1;
      }
      this.setNewCurrentPhoto();
    },
    // Renew story object for dynamic update it's event listener for story-update event
    getStampObj(obj) {
      this.parsedStory = obj;
    },
    // // Trigger for points
    updateStoryShape() {
      this.changeShape = !this.changeShape;
    },
    // Wrapper for passing parameters inside getPacks function
    myDebounce: _.debounce((params, func) => {
      func(params);
    }, 300),

    // Get pack list from DB
    getPacks() {
      let that = this;
      // _.debounce(() => {
      that.$http.get(`${that.host}/cp/packs/ajax/titles`, {}).then((success) => {
        console.log('success ', success);
        that.packsList = success.body.packs;
        that.stampsList = '';
        that.getCommonPackContent(that.packsList);
      }, (error) => {
        console.log('error ', error);
      });
      // }, 500)();
    },
    getCommonPackContent(packList) {
      let that = this;
      packList.forEach(function (item) {
        if (item.title.toLowerCase() === 'common') {
          that.$http.get(`${that.host}/cp/packs/ajax/content`, {
            params: {
              pack_id: item.id
            }
          }).then((success) => {
            that.commonPack = success.body.content;
            // console.log('that.commonPack success ', success);
          }, (error) => {
            // console.log('getCommonPackContent error ', error);
          });
        }
      });
    },
    // Receive stamps from selected pack from server
    getStampsFromServer(id) {
      this.$http.get(`${this.host}/cp/packs/ajax/content`, {
        params: {
          pack_id: id
        }
      }).then((success) => {
        console.log('success ', success);
        this.stampsList = success.body.content;
        this.showPacksTrigger = false;
      }, (error) => {
        console.log('error ', error);
      });
    },
    // Adding new stamp to story from server
    addStampToStoryArray(stampId, storyId) {
      let that = this;
      let loaderStatus = true;
      previewService.loaderService(that.loader, loaderStatus);
      that.$http.post(`${that.host}/cp/stories/${storyId}/content`, {id: stampId})
        .then((success) => {
          console.log('new stamp added ', success);
          // location.reload();
          // fixme: save stamps changes before adding new stamp
          that.parsedStory.data.content.push(success.body.content);
          console.warn('new stamp ', success.body.content);
          previewService.loaderService(that.loader, !loaderStatus);
          that.updateComponents();
          // that.updateStampHttp();
        }, (error) => {
          console.error('error ', error);
          previewService.loaderService(that.loader, !loaderStatus);
        });
    },
    deleteAndReload(story, stamp) {
      this.stampIndex = null;
      this.updateStampHttp();
    },
    demoInMessenger(e) {
      this.updateStampHttp().then((success) => {
        console.log('success ', success);
      }, (error) => {
        console.log('error ', error);
      });
    },
    sortByOrder(a, b) {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    },
    sortArrayWithoutMutating(arr) {
      return arr.concat().sort(this.sortByOrder);
    },
    sortArrayByType(storyContent) {
      let typeFrameArr = [];
      let elseTypesArr = [];
      storyContent.forEach(function (stamp) {
        if (stamp.type === 'frame') {
          typeFrameArr.push(stamp);
        } else {
          elseTypesArr.push(stamp);
        }
      });
      return typeFrameArr.concat(elseTypesArr);
    },
    // Save stamps changes to server
    updateStampHttp() {
      console.log('parsedStory.data.content ', this.parsedStory.data.content);
      let that = this;
      let promiseAllArray = [];
      let sortedArrayByOrder;
      let sortedByType;
      let loaderStatus = true;
      previewService.loaderService(that.loader, loaderStatus);
      if (!window.VUEMAINSTK.$children[0].storyId) {
        that.storyId = that.parsedStory.data.id;
      }
      sortedArrayByOrder = this.sortArrayWithoutMutating(this.parsedStory.data.content);
      sortedByType = this.sortArrayByType(sortedArrayByOrder);
      sortedByType.forEach((item, i, arr) => {
        item.order = i + 1;
        if (item.delta_rotation < 0) {
          item.delta_rotation += 360;
        }
        promiseAllArray.push(that.$http
          .put(`${that.host}/cp/stories/${that.storyId}/content/${item.pivot_id}`, {
            stamp: item,
            photo_type: that.photoType
          }));
      });
      return Promise.all(promiseAllArray)
        .then((success) => {
          console.log('success ', success);
          previewService.loaderService(that.loader, !loaderStatus);
          that.updateComponents();
          // location.reload();
        }, (error) => {
          previewService.loaderService(that.loader, !loaderStatus);
          that.updateComponents();
          console.log('error ', error);
        });
    },
    framePositionChanged() {
      this.framePositionTrigger = !this.framePositionTrigger;
    },
    getStaticStampChanges(staticObject) {
      this.staticStampChanges = staticObject;
    },
    cancelStampSelecting() {
      this.updateComponents();
      this.stampIndex = null;
    },
    stopClosingLists(event) {
      console.warn('stopClosingLists');
      event.stopPropagation();
    },
    cleanPacksAndStampsLists() {
      this.stampsList = '';
      this.showPacksTrigger = false;
    },
    cleanPacksAndStampsListsEscape(e) {
      if (e.keyCode === 27) {
        this.packsQuery = '';
        this.stampsList = '';
        this.showPacksTrigger = false;
        console.log('this.stampsList ', this.stampsList);
      }
    },
    showPackList() {
      this.showPacksTrigger = true;
    },
    preloadImages(photoArray) {
      let urlArray = [];
      photoArray.forEach(function (item) {
        urlArray.push(item.vertical.url);
        urlArray.push(item.square.url);
      });
      let preloadImages = [];
      for (let i = 0; i < urlArray.length; i += 1) {
        preloadImages[i] = new Image();
        preloadImages[i].src = urlArray[i];
      }
      // console.log(preloadImages);
    },
    dropZoneUpdatedStory(story) {
      this.parsedStory = story;
      this.updateComponents();
    },
    updateCommonPack(commonArray) {
      this.commonPack = commonArray;
    },
    updateLoader(loaderStatus) {
      let that = this;
      previewService.loaderService(that.loader, loaderStatus);
    },
    removeStampFromStampsPack(contentId, stampsPack) {
      for (let i = stampsPack.length - 1; i >= 0; i -= 1) {
        if (stampsPack[i].content_id === contentId) {
          stampsPack.splice(i, 1);
        }
      }
      return stampsPack;
    },

    deleteCommonStamp(e, contentId, stamp) {
      let that = this;
      let loaderStatus = true;
      previewService.loaderService(that.loader, loaderStatus);
      e.stopPropagation();
      if (that.usage === 'landing') {
        let stampIndex = that.story.data.content.indexOf(stamp);
        that.story.data.content.splice(stampIndex, 1);
        that.commonPack = that.removeStampFromStampsPack(contentId, that.commonPack);
        previewService.loaderService(that.loader, !loaderStatus);
      } else {
        that.$http.delete(`${that.host}/cp/packs/stamp`, {
          params: {
            content_id: contentId
          }
        }).then((success) => {
          console.log('deleted ', success);
          that.commonPack = that.removeStampFromStampsPack(contentId, that.commonPack);
          previewService.loaderService(that.loader, !loaderStatus);
        }, (error) => {
          console.log('not deleted ', error);
          previewService.loaderService(that.loader, !loaderStatus);
        });
      }
    },
    propagateVerticalComponent() {
      this.verticalLoadStart = !this.verticalLoadStart;
    },
    propagateSquareComponent() {
      this.squareLoadStart = !this.squareLoadStart;
    },
    beginSave() {
      let that = this;
      // console.log(that.square);
      if (that.photoType === 'vertical') {
        that.propagateVerticalComponent();
        // PreviewService.createCanvasStory();
      } else if (that.photoType === 'square') {
        that.propagateSquareComponent();
      }
    },
    generateSavedCanvas(data) {
      let loaderStatus = true;
      let that = this;
      let canvas = that.$refs.canvasTest;
      let link = that.$refs.download;
      let photoUrl;
      let photoSize;
      if (that.photoType === 'vertical') {
        photoUrl = that.currentPhoto.vertical.url;
        photoSize = that.size;
      } else if (that.photoType === 'square') {
        photoUrl = that.currentPhoto.square.url;
        photoSize = that.squareSize;
      }
      console.log(data);
      console.log(photoSize);
      previewService.loaderService(that.loader, loaderStatus);
      previewService.createCanvasStory(canvas, photoUrl, photoSize, data.size, data.stamps, link).then((success) => {
        previewService.loaderService(that.loader, !loaderStatus);
        console.log('success ', success);
      }, (error) => {
        previewService.loaderService(that.loader, !loaderStatus);
        console.log('error ', error);
      });
    },
    addUserImagesToPhotoArray(photoUrl, squarePhotoUrl, faceLandmarks, squareFaceLandmarks, photoArray, currentPhotoIndex) {
      let currentPhoto;
      if (photoUrl && squarePhotoUrl) {
        console.log('that.photoUrl ', photoUrl);
        let middleWareArray = [];
        middleWareArray.push({
          vertical: {
            faceLandmarks,
            url: photoUrl
          },
          square: {
            faceLandmarks: squareFaceLandmarks,
            url: squarePhotoUrl
          }
        });
        photoArray = middleWareArray.concat(photoArray);
        currentPhoto = photoArray[currentPhotoIndex];
      } else {
        currentPhoto = photoArray[currentPhotoIndex];
      }
      return {currentPhoto, photoArray};
    }
  },
  computed: {
    photoType() {
      return this.square ? 'square' : 'vertical';
    },
    filteredPacks() {
      let result = this.packsList;
      if (result && this.packsQuery.trim() !== '') {
        result = result.filter(item => item.title.toLowerCase().includes(this.packsQuery.toLowerCase()));
      }
      return result;
    }
  },
  destroyed() {
    let that = this;
    window.removeEventListener('click', that.cleanPacksAndStampsLists);
    window.removeEventListener('keyup', that.cleanPacksAndStampsListsEscape);
  },
  mounted() {
    let that = this;
    that.loader = document.getElementsByClassName('loader')[0];
    let imagesArray = that.addUserImagesToPhotoArray(that.photoUrl, that.squarePhotoUrl, that.faceLandmarks, that.squareFaceLandmarks, that.photoArray, that.currentPhotoIndex);
    that.currentPhoto = imagesArray.currentPhoto;
    that.photoArray = imagesArray.photoArray;
    this.getPacks();
    console.log('this.currentPhoto ', this.currentPhoto);
    // this event listener hides 'pack list' and 'stamp list' if you click outside elsewhere
    window.addEventListener('click', that.cleanPacksAndStampsLists);
    window.addEventListener('keyup', that.cleanPacksAndStampsListsEscape);
    that.preloadImages(that.photoArray);
  }
});



// WEBPACK FOOTER //
// ./src/js/story-editor-component.js